import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CanvasLayoutDataService } from 'src/app/submodules/angular-common/canvas-layout-data.service';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';
import { LocaleDataService } from '../../../../submodules/angular-common/locale-data.service';
import { SecurityDataService } from '../../../../submodules/angular-common/security-data.service';
import { BaseView } from '../../../../submodules/angular-ui-common/base-view';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseView implements OnInit {

  frontImage="./assets/images/home.svg";

  constructor(
    public securityDataService:SecurityDataService,
    public localeDataService:LocaleDataService,
    public canvasLayoutDataService:CanvasLayoutDataService,
    private _router: Router,
    protected _injector: Injector
   ) { 
    super(_injector);
    this._injector.get(PageLayoutDataService).init({
      layoutType: 0,
      verticallyCentered:true,
      showBreadcrumbs:false})
  }

  async ngOnInit() {
    // if(this.securityDataService.isAuthenticated()) {
    //   try {
    //     await this._injector.get(SecurityDataService).getSecurityContext()
    //     this._router.navigate(['/private/home']);
    //   } catch (error) {
    //     //NOTHING TO DO
    //   }
    // }
    this._injector.get(PageLayoutDataService).loading = false;
  }

  accedi(){
    this._router.navigate(['/private/home']);
  }
}